'use client'

import { InsurableLimits } from '@/components/InsurableLimits/InsurableLimits'
import { useProductData, useSelectedProductVariant } from '@/components/ProductData/ProductDataProvider'
import { storyblokEditable } from '@storyblok/react'

export const InsurableLimitsBlock = () => {
  const selectedVariant = useSelectedProductVariant()
  const productData = useProductData()

  const selectedProductVariant = productData.variants.find(
    (item) => item.typeOfContract === selectedVariant?.typeOfContract,
  )

  const productVariant = selectedProductVariant ?? productData.variants[0]

  return <InsurableLimits items={productVariant.insurableLimits} {...storyblokEditable} />
}
InsurableLimitsBlock.blockName = 'insurableLimits'
